import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './ListItem.module.less';
import hotImg from '../../../static/game/hot_tag.svg';
import gameSelected from '../../../static/game/game_selected.svg';
import gameUnselected from '../../../static/game/game_unselect.svg';
import { setSelectedTag, setSelectedATag } from '../../../actions/game';
import { logging, logPostInfo } from '../../../actions/log';

const SelectShowCategoryTag = createSelector(
  state => state.game,
  game => game.showCategoryList,
);

const SelectGameSelectTag = createSelector(
  state => state.game,
  game => game.categorySelectedTag,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ code, tagInfo = {} }) => {
  const dispatch = useDispatch();
  const categoryTag = useSelector(SelectShowCategoryTag);
  const gameSelectTag = useSelector(SelectGameSelectTag);
  const logInfoData = useSelector(selectLogInfo);

  const point = info => {
    dispatch(
      logging({
        category: 'C',
        action: 'Game_Base_Sizer',
        label: '',
        param2: {
          source: 'Game_Base',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          value: info.tagId ?? info.childCode,
          type: tagInfo?.groupName,
          name: info?.tagName ?? info?.childName,
        },
      }),
    );
  };

  const clickTag = useCallback(
    (info, e) => {
      e.stopPropagation();
      e.preventDefault();
      let params = {
        code,
        info,
      };
      dispatch(setSelectedTag(params));
      point(info);
    },
    [code, categoryTag, gameSelectTag],
  );

  const clickATag = useCallback(
    info => {
      let params = {
        code,
        info,
      };
      dispatch(setSelectedATag(params));
      point(info);
    },
    [code, categoryTag, gameSelectTag],
  );

  return (
    <div className={styles.list_item}>
      {code === '1' && (
        <>
          {tagInfo?.groupType === 1 && tagInfo?.tags?.length > 0 && (
            <div className="hot_tag">
              <div className="hot_tag_title">
                <img src={hotImg} />
                <div>{tagInfo.groupName}</div>
              </div>

              <div className="hot_tag_info">
                {tagInfo?.tags?.map((tag, i) => (
                  <div
                    key={i}
                    className={`hot_tag_item ${tag.tagSelect === 1 ? 'tag_item_select' : ''}`}
                    onClick={e => clickTag(tag, e)}
                  >
                    {tag.tagName}
                  </div>
                ))}
              </div>
            </div>
          )}
          {tagInfo?.groupType === 0 && tagInfo?.tags?.length > 0 && (
            <div className="ordinary_tag">
              <div className="ordinary_tag_title">{tagInfo.groupName}</div>
              {tagInfo?.tags?.map((tag, k) => (
                <div key={k} className="ordinary_tag_item" onClick={e => clickTag(tag, e)}>
                  <img src={tag.tagSelect === 1 ? gameSelected : gameUnselected} />
                  <div>{tag?.tagName}</div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {code === '2' && (
        <div className="a_ordinary">
          {tagInfo?.childClassList?.map((tag, k) => (
            <div key={k} className="a_ordinary_tag_item" onClick={() => clickATag(tag)}>
              <img src={tag.tagSelect === 1 ? gameSelected : gameUnselected} />
              <div>{tag?.childName}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
});
